var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.69231H13.0769C13.3231 7.69231 13.5385 7.47692 13.5385 7.23077V6.30769C13.5385 6.06154 13.3231 5.84615 13.0769 5.84615H8C7.81538 5.84615 7.69231 5.72308 7.69231 5.53846V0.461538C7.69231 0.215385 7.47692 0 7.23077 0H6.30769C6.06154 0 5.84615 0.215385 5.84615 0.461538V5.53846C5.84615 5.72308 5.72308 5.84615 5.53846 5.84615H0.461538C0.215385 5.84615 0 6.06154 0 6.30769V7.23077C0 7.47692 0.215385 7.69231 0.461538 7.69231H5.53846C5.72308 7.69231 5.84615 7.81538 5.84615 8V13.0769C5.84615 13.3231 6.06154 13.5385 6.30769 13.5385H7.23077C7.47692 13.5385 7.69231 13.3231 7.69231 13.0769V8C7.69231 7.81538 7.81538 7.69231 8 7.69231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddingIcon);
export default __webpack_public_path__ + "static/media/adding-icon.c27108f1369078f885067a43a061c9b8.svg";
export { ForwardRef as ReactComponent };